import App from 'next/app';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'next/router';
import store from 'store';
import { DM_Sans as DMSans } from 'next/font/google';
// import { Global, css } from '@emotion/core';
import { SWRConfig as Config } from 'swr';
import { ThemeProvider } from 'emotion-theming';
import * as Sentry from '@sentry/node';
import PDFProcessor from '@/components/PDFProcessor/index';
import theme from '@/lib/theme';
import EntityCache, { useReceivePayload } from '@/lib/entities';
import Auth from '@/components/Auth';
import '@reach/dialog/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ax, fetcher } from '@/lib/api';
import ConfirmationOverlay from '@/components/app/ConfirmationOverlay';
import ConfirmationOverlayManual from '@/components/app/ConfirmationOverlayManual';
import PendingCelebration from '@/components/PendingCelebration';
import BrowserWarning from '@/components/app/BrowserWarning';
import Favicons from '@/components/Favicons';
import Referrals from '@/components/Referrals/index';
import FlashMessages from '@/components/FlashMessages';
import SentryLogsTracker from '@/components/app/SentryLogsTracker';
import { OnlineStatusProvider } from '@/hooks/useOnlineStatus';
import { VideoUploadContextList } from '@/components/ContributorRecord/VideoUploadContext';
import packageJson from '../package.json';
import './styles.css';
// import { removeParam } from '@/lib/helper';

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    enabled: process.env.NODE_ENV === 'production',
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  });
}
export async function checkVersion() {
  const {
    data: {
      data: { attributes },
    },
  } = await ax({ versionNumber: packageJson.version }).get(`/v3/my/api_server`);
  if (
    attributes['advice-for-application'] === 'upgrade_required' ||
    attributes['advice-for-application'] === 'upgrade_suggested' ||
    attributes['advice-for-application'] === 'invalid_version_provided'
  ) {
    // eslint-disable-next-line no-self-assign
    window.location.href = window.location.href;
    caches.keys().then(async (names) => {
      await Promise.all(names.map((name) => caches.delete(name)));
    });
    window.location.reload(true);
  }
}

function SWRConfig({ children }) {
  const receivePayload = useReceivePayload();
  return (
    <Config
      value={{
        fetcher,
        shouldRetryOnError: false,
        onSuccess: (payload) => {
          receivePayload(payload.data, payload.config.url);
        },
        focusThrottleInterval: 30000,
      }}
    >
      {children}
    </Config>
  );
}
SWRConfig.propTypes = {
  children: PropTypes.node.isRequired,
};

/* eslint-disable no-param-reassign, no-underscore-dangle, prefer-rest-params */
function loadRewardFul(r) {
  const w = window;
  w._rwq = r;
  w[r] =
    w[r] ||
    function () {
      (w[r].q = w[r].q || []).push(arguments);
    };
}

function loadGoogleTagManagaer(d, s, l, i) {
  const w = window;
  // eslint-disable-next-line no-param-reassign
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const f = d.getElementsByTagName(s)[0];
  const j = d.createElement(s);
  const dl = l !== 'dataLayer' ? `&l=${l}` : '';
  j.async = true;
  j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
  f.parentNode.insertBefore(j, f);
}

function loadBeacon() {
  /* eslint-disable consistent-return, no-shadow, no-unused-expressions, no-cond-assign, no-multi-assign, no-sequences  */
  !(function (e, t, n) {
    function a() {
      const e = t.getElementsByTagName('script')[0];
      const n = t.createElement('script');
      (n.type = 'text/javascript'),
        (n.async = !0),
        (n.src = 'https://beacon-v2.helpscout.net'),
        e.parentNode.insertBefore(n, e);
    }
    if (
      ((e.Beacon = n =
        function (t, n, a) {
          e.Beacon.readyQueue.push({ method: t, options: n, data: a });
        }),
      (n.readyQueue = []),
      t.readyState === 'complete')
    )
      return a();
    e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, !1);
  })(window, document, window.Beacon || function () {});
}

const dmSans = DMSans({
  weight: ['400', '500', '600', '700', '800', '900'],
  subsets: ['latin'],
});

class MyApp extends App {
  componentDidMount() {
    checkVersion();
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        checkVersion();
      }
    });
    // if (process.env.NEXT_PUBLIC_HOTJAR_ID) {
    //   const hjid = process.env.NEXT_PUBLIC_HOTJAR_ID;
    //   const hjsv = process.env.NEXT_PUBLIC_HOTJAR_SNIPPET_VERSION;
    //   hotjar.initialize({
    //     id: hjid,
    //     sv: hjsv,
    //   });
    // }
    if (!window.location.href.includes('/invitations')) {
      if (
        process.env.NEXT_PUBLIC_GTM_ID &&
        process.env.NEXT_PUBLIC_GTM_ID !== '@next-public-gtm-id-preview-i5ph'
      ) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'vwoCode';
        script.innerHTML = `
    window._vwo_code || (function() {
    var account_id=730537,
    version=2.0,
    settings_tolerance=2000,
    hide_element='body',
    hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
    /* DO NOT EDIT BELOW THIS LINE */
    f=false,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?window.sessionStorage:window.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!window.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();window._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',o=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));o.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};window._vwo_code=code;code.init();})();
    `;

        document.head.appendChild(script);
      }

      const impactScript = document.createElement('script');
      impactScript.type = 'text/javascript';
      impactScript.id = 'impactCode';
      impactScript.innerHTML = `
    (function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){(e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);})('https://utt.impactcdn.com/A5020859-e12d-4adc-a102-2bad710bd95d1.js','script','ire',document,window); 
  `;
      document.head.appendChild(impactScript);

      loadBeacon();
      // window.Beacon('init', 'dbacea8a-27a7-4ba0-ba2a-d21ebc46db30');
      loadRewardFul('rewardful');
    }
    if (process.env.NEXT_PUBLIC_GTM_ID) {
      loadGoogleTagManagaer(document, 'script', 'dataLayer', process.env.NEXT_PUBLIC_GTM_ID);
    }
  }

  render() {
    const { Component, pageProps, err } = this.props;
    const currentRoute = this.props?.router?.state?.asPath;
    if (currentRoute !== store.get('path')) store.set('path', this.props?.router?.state?.asPath);
    return (
      <>
        <style>{`
          html {
            font-family: ${dmSans.style.fontFamily};
          }
          textarea {
            font-family: ${dmSans.style.fontFamily};
          }
        `}</style>
        <ThemeProvider theme={theme}>
          <SentryLogsTracker />
          <EntityCache initialPayload={pageProps.initialData}>
            <SWRConfig>
              <Referrals>
                <Auth>
                  <PDFProcessor>
                    <FlashMessages>
                      <BrowserWarning />
                      <PendingCelebration>
                        <Favicons />
                        <OnlineStatusProvider>
                          <ConfirmationOverlayManual>
                            <ConfirmationOverlay>
                              <VideoUploadContextList>
                                <Component {...pageProps} err={err} />
                              </VideoUploadContextList>
                            </ConfirmationOverlay>
                          </ConfirmationOverlayManual>
                        </OnlineStatusProvider>
                      </PendingCelebration>
                    </FlashMessages>
                  </PDFProcessor>
                </Auth>
              </Referrals>
            </SWRConfig>
          </EntityCache>
        </ThemeProvider>
      </>
    );
  }
}

export default withRouter(MyApp);
